import AllTempBillingReports from "../../components/temp-billing-imports";

const TempBillingImports = () => <AllTempBillingReports />

export default TempBillingImports;